export const END_INSTRUCTION_VIEW = 'END_INSTRUCTION_VIEW';
export const CONFIRM_BUTTON = 'CONFIRM_BUTTON';
